const runtimeEnv = window.__ENV__ || {};

const dev = {
  API_ENDPOINT_URL: 'https://rebeca.app/api/dev/',
  BASE_URL: 'https://rebeca.app'
};

const prod = {
  API_ENDPOINT_URL: 'https://rebeca.travel/api/dev',
  BASE_URL: 'https://rebeca.travel'
};

const getEnv = () => {
	// Prefer runtime config from configmap (window.__ENV__)
	if (runtimeEnv.API_ENDPOINT_URL) {
		return runtimeEnv;
	}

	// Fallback to build-time environment detection
	const buildEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
	
	switch (buildEnv) {
		case 'development':
			return dev
		case 'production':
			return prod
		default:
			return dev;
	}
}

export const env = getEnv()
